export const CONFIG_LS_KEY = "config"
export const APP_SETTINGS_LS_KEY = "settings"
